export default "__VITE_ASSET__BnhoCpeu__"